
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2a491d2a&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AlertGlobal.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./AlertGlobal.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-2a491d2a!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AlertGlobal.vue"),
  /* scopeId */
  "data-v-2a491d2a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/modal/AlertGlobal.vue
// module id = 492
// module chunks = 1